import React, { useEffect } from 'react';

interface DecorationTextProps {
  text: string;
  functions?: { [key: string]: () => void };
}

const parseHTML = (text: string) => {
  // 特殊なimgタグのパース

  const imgTagWithOnClickRegex = /<img\s*onClick="(\w+)"\s*>(https?:\/\/[^\s]+)<\/img>/g;
  text = text.replace(imgTagWithOnClickRegex, (match, functionName, url) => {
    return `<img data-function="${functionName}" src='${url}' alt='image' />`;
  });

  // リンク付き画像タグのパース
  const imgTagWithLinkRegex = /<img\s*link="(https?:\/\/[^\s]+)"\s*>(https?:\/\/[^\s]+)<\/img>/g;
  text = text.replace(imgTagWithLinkRegex, (match, link, url) => {
    return `<a href="${link}" target="_blank" rel="noopener noreferrer"><img src='${url}' alt='image' /></a>`;
  });

  // 通常の画像タグのパース
  const imgTagRegex = /<img>(https?:\/\/[^\s]+)<\/img>/g;
  text = text.replace(imgTagRegex, "<img src='$1' alt='image' />");

  // テキストの変換処理
  text = text.replace(/<bold>/g, "<span style='font-weight: bold;'>");
  text = text.replace(/<\/bold>/g, '</span>');
  text = text.replace(/<red>/g, "<span style='color: #da120a'>");
  text = text.replace(/<\/red>/g, '</span>');
  text = text.replace(/<big>/g, "<span style='font-size: 21px;'>");
  text = text.replace(/<\/big>/g, '</span>');
  text = text.replace(/<center>/g, "<span style='text-align:center'>");
  text = text.replace(/<\/center>/g, '</span>');
  // リンク表示
  text = text.replace(
    /<link>(.+)<\/link>/g,
    "<a href='$1'><span style='color: #0000ff; text-decoration: underline; text-underline-offset:1.5px'>$1</span></a>",
  );

  text = text.replace(
    /<underBar>/g,
    "<span style='text-decoration: underline; text-underline-offset:1.5px '>",
  );
  text = text.replace(/<\/underBar>/g, '</span>');

  text = text.replace(
    /{{占い師の名前}}/g,
    "<span style='background-color: #fff0f6; border-color: #ffadd2; color: #c41d7f; border: 1px solid; padding: 2px; margin: 0 4px; font-size: 12px;'>占い師の名前</span>",
  );
  text = text.replace(
    /{{自分の名前}}/g,
    "<span style='background-color: #fff0f6; border-color: #ffadd2; color: #c41d7f; border: 1px solid; padding: 2px; margin: 0 4px; font-size: 12px;'>自分の名前</span>",
  );
  text = text.replace(
    /{{相手の名前}}/g,
    "<span style='background-color: #fff0f6; border-color: #ffadd2; color: #c41d7f; border: 1px solid; padding: 2px; margin: 0 4px; font-size: 12px;'>相手の名前</span>",
  );
  text = text.replace(
    /{{悩み}}/g,
    "<span style='background-color: #fff0f6; border-color: #ffadd2; color: #c41d7f; border: 1px solid; padding: 2px; margin: 0 4px; font-size: 12px;'>悩み</span>",
  );
  text = text.replace(/<br>/g, '<br/>');

  return text;
};

export const DecorationText: React.VFC<DecorationTextProps> = ({ text, functions }) => {
  useEffect(() => {
    const imgTags = document.querySelectorAll('.decoration-text img[data-function]');
    imgTags.forEach((img) => {
      const functionName = img.getAttribute('data-function');
      if (functionName && functions[functionName]) {
        img.addEventListener('click', functions[functionName]);
      }
    });

    // クリーンアップ関数
    return () => {
      imgTags.forEach((img) => {
        const functionName = img.getAttribute('data-function');
        if (functionName && functions[functionName]) {
          img.removeEventListener('click', functions[functionName]);
        }
      });
    };
  }, [functions]);

  if (!text) return <></>;

  const parsedHTML = parseHTML(text);

  return (
    <div
      className="decoration-text"
      dangerouslySetInnerHTML={{
        __html: parsedHTML,
      }}
    />
  );
};
